import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        // Backend now sets an httpOnly session cookie — no localStorage needed.
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.user?.role === "admin" ? "/dashboard" : "/portal";
        navigate(dest, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Authentication failed");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex items-center justify-center h-screen" data-testid="auth-callback">
      <div className="text-zinc-700 label-overline">
        {error || "Completing sign-in…"}
      </div>
    </div>
  );
}
